import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useFetchPrescriptionScriptDetails(parameters, isEnabled) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useFetchPrescriptionScriptDetails";

  async function FetchPrescriptionScriptDetails() {
    const accessToken = oktaAuth.getAccessToken();

    var result = await axios
      .get("api/PaymentException/GetScriptDetails", {
        params: parameters,
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });

    return result;
  }

  return useQuery({
    queryKey: [dataKey, parameters],
    queryFn: async () => await FetchPrescriptionScriptDetails(),
    enabled: isEnabled,
    refetchOnWindowFocus: false
  });
}
